// prettier-ignore
export const GettingStarted = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24'>
    <path fill='currentColor' fillRule='evenodd' clipRule='evenodd'
          d='M8.36 1.54A1 1 0 0 1 9.25 1h9a1 1 0 0 1 .79 1.62L14.8 8h5.44a1 1 0 0 1 .73 1.68l-12 13a1 1 0 0 1-1.7-.93l2.17-8.25h-5.7a1 1 0 0 1-.89-1.46l5.5-10.5ZM9.86 3 5.4 11.5h5.35a1 1 0 0 1 .97 1.25l-1.48 5.62L17.97 10h-5.22a1 1 0 0 1-.79-1.62L16.2 3H9.86Z' />
  </svg>
)
